'use strict'

import Vue from 'vue'
import axios from 'axios'

// middlewares
import loading from '@/middleware/loading'
import errors from '@/middleware/errors'

let config = {
  baseURL: process.env.VUE_APP_BASE_URL || process.env.apiUrl,
  withCredentials: true
}

const _axios = axios.create(config)

loading(_axios)
errors(_axios)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      }
    },
    $axios: {
      get () {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
